import { localStorageKeys } from '@/common/storage-keys'
import { localStorage } from '@/utils/storage'
import i18n from '@/i18n'

// Khởi tạo ngôn ngữ
const initLanguage = function () {
  const language: string = localStorage.get(localStorageKeys.LOCALIZE) || 'vi'
  const { locale } = require('element-plus')
  const lang = require(`./src/${language}.js`)

  if (locale && lang) {
    require(`dayjs/locale/${language}.js`)
    locale(lang?.default)

    if (i18n && i18n.global) {
      i18n.global.locale = language
    }
  }
}

// Thay đổi ngôn ngữ
const changeLangue = function (language: string) {
  localStorage.set(localStorageKeys.LOCALIZE, language)
  window.location.reload()
}

export { initLanguage, changeLangue }
